const oneBtcInSatoshiCal = 100000000;
const maxBtcSupply = 21000000;
const maxSatsSupply = maxBtcSupply * oneBtcInSatoshiCal; // 2,100,000,000,000,000

// Get max value based on currency type
function getMaxForCurrency(currency) {
    switch (currency) {
        case 'BTC':
            return maxBtcSupply;
        case 'SATS':
            return maxSatsSupply;
        case 'EUR':
        case 'USD':
            // Calculate max fiat based on current BTC price × 21M
            try {
                let btcPrices = JSON.parse(localStorage.btcprices);
                let btcPriceItem = btcPrices.data.find(item => item.code === currency);
                if (btcPriceItem) {
                    return Math.ceil(btcPriceItem.rate * maxBtcSupply);
                }
            } catch (e) {}
            return 10000000000000; // Fallback: 10 trillion
        default:
            return 10000000000000;
    }
}

// Update input limits based on selected currency
function updateInputLimits(inputId, selectId, rootClass) {
    const selectEl = document.getElementById(selectId);
    const currency = selectEl.value;
    const maxVal = getMaxForCurrency(currency);

    const inputEl = document.getElementById(inputId);
    const root = inputEl ? inputEl.closest('.' + rootClass) : null;
    const rangeEl = root ? root.querySelector('.satscal-input-range') : null;

    if (inputEl) {
        inputEl.setAttribute('max', maxVal);
        // Clamp current value if exceeds new max
        if (parseFloat(inputEl.value) > maxVal) {
            inputEl.value = maxVal;
        }
    }

    if (rangeEl) {
        rangeEl.setAttribute('max', maxVal);
        // Adjust step for large values
        if (currency === 'SATS') {
            rangeEl.setAttribute('step', '100000000'); // 1 BTC steps
        } else if (currency === 'BTC') {
            rangeEl.setAttribute('step', '0.1');
        } else {
            rangeEl.setAttribute('step', '1000');
        }
        if (parseFloat(rangeEl.value) > maxVal) {
            rangeEl.value = maxVal;
        }
    }
}

function handleInputTypeChangeFrom(event) {
    updateInputLimits('satscal-input-value-from', 'satscalfrom', 'satscal-form-from');
    calculateSats(true);
}


function handleInputTypeChangeTo(event) {
    updateInputLimits('satscal-input-value-to', 'satscalto', 'satscal-form-to');
    calculateSats(false);
}

// Clamp calculated value to currency max and set to input
function setClampedValue(elementId, value, currency) {
    const maxVal = getMaxForCurrency(currency);
    const clampedValue = Math.min(parseFloat(value), maxVal);
    document.getElementById(elementId).value = clampedValue;
}

function calculateSats(straight) {
    let currency = 'EUR';
    const from = document.getElementById('satscalfrom').value;
    const to = document.getElementById('satscalto').value
    if (from === 'EUR' || to === 'EUR') {
        currency = 'EUR'
    }
    if (from === 'USD' || to === 'USD') {
        currency = 'USD'
    }
    let flow = '';
    if (straight) {
        flow = from + to
    } else {
        flow = to + from
    }
    //console.log("FLOW", flow)
    let amountFrom = document.getElementById('satscal-input-value-from').value;
    let amountTo = document.getElementById('satscal-input-value-to').value;

    // Clamp input values to their respective currency max
    const fromMax = getMaxForCurrency(from);
    const toMax = getMaxForCurrency(to);
    if (parseFloat(amountFrom) > fromMax) {
        amountFrom = fromMax;
        document.getElementById('satscal-input-value-from').value = fromMax;
    }
    if (parseFloat(amountTo) > toMax) {
        amountTo = toMax;
        document.getElementById('satscal-input-value-to').value = toMax;
    }
    //console.log("AMOUNTS", amountFrom, amountTo)
    let btcPricesCal = JSON.parse(localStorage.btcprices);
    let btcPriceItemCal = btcPricesCal.data.find(item => item.code === currency)
    //console.log("btcPriceItem: ", btcPriceItemCal)
    /* 1 BTC in Satoshi / Current BTC Price in Cent = Satoshi per cent */
    let satoshiPerCentCal = oneBtcInSatoshi / (btcPriceItemCal.rate * 100)
    //console.log("satoshiPerCent: ", satoshiPerCentCal)
    /* EUR USD DIFF */
    let btcPriceUsd = btcPricesCal.data.find(item => item.code === 'USD').rate
    let btcPriceEur = btcPricesCal.data.find(item => item.code === 'EUR').rate
    let usdEurDiff = btcPriceUsd / btcPriceEur
    //console.log(btcPriceUsd, btcPriceEur, usdEurDiff)
    switch (flow) {
        case "SATSSATS":
        case "BTCBTC":
        case "EUREUR":
            if (straight) {
                document.getElementById('satscal-input-value-from').value = amountFrom;
                document.getElementById('satscal-input-value-to').value = amountFrom;
            } else {
                document.getElementById('satscal-input-value-from').value = amountTo;
                document.getElementById('satscal-input-value-to').value = amountTo;
            }
            break;
        case "EURUSD":
            if (straight) {
                let calculatedValueEurToUsdR = (amountFrom * usdEurDiff).toFixed(2);
                document.getElementById('satscal-input-value-to').value = calculatedValueEurToUsdR;
            } else {
                let calculatedValueEurToUsd = (amountTo * usdEurDiff).toFixed(2);
                document.getElementById('satscal-input-value-from').value = calculatedValueEurToUsd;
            }
            break;
        case "USDEUR":
            if (straight) {
                let calculatedValueEurToUsdR = (amountFrom / usdEurDiff).toFixed(2);
                document.getElementById('satscal-input-value-to').value = calculatedValueEurToUsdR;
            } else {
                let calculatedValueEurToUsd = (amountTo / usdEurDiff).toFixed(2);
                document.getElementById('satscal-input-value-from').value = calculatedValueEurToUsd;
            }
            break;
        case "SATSEUR":
            if (straight) {
                let calculatedValueSatsToEurR = ((amountFrom / satoshiPerCentCal) / 100).toFixed(2);
                document.getElementById('satscal-input-value-to').value = calculatedValueSatsToEurR;
            } else {
                let calculatedValueSatsToEur = ((amountTo / satoshiPerCentCal) / 100).toFixed(2);
                document.getElementById('satscal-input-value-from').value = calculatedValueSatsToEur;
            }
            break;
        case "SATSUSD":
            if (straight) {
                let calculatedValueSatsToEurR = ((amountFrom / satoshiPerCentCal) / 100).toFixed(2);
                document.getElementById('satscal-input-value-to').value = calculatedValueSatsToEurR;
            } else {
                let calculatedValueSatsToEur = ((amountTo / satoshiPerCentCal) / 100).toFixed(2);
                document.getElementById('satscal-input-value-from').value = calculatedValueSatsToEur;
            }
            break;
        case "SATSBTC":
            if (straight) {
                let calculatedValueSatsToBtcR = (amountFrom / oneBtcInSatoshiCal).toFixed(8);
                document.getElementById('satscal-input-value-to').value = calculatedValueSatsToBtcR;
            } else {
                let calculatedValueSatsToBtc = (amountTo / oneBtcInSatoshiCal).toFixed(8);
                document.getElementById('satscal-input-value-from').value = calculatedValueSatsToBtc;
            }
            break;
        case "BTCEUR":
            if (straight) {
                let calculatedValueBtcToEurR = (((amountFrom * oneBtcInSatoshiCal) / satoshiPerCentCal) / 100).toFixed(2);
                document.getElementById('satscal-input-value-to').value = calculatedValueBtcToEurR;
            } else {
                let calculatedValueBtcToEur = (((amountTo * oneBtcInSatoshiCal) / satoshiPerCentCal) / 100).toFixed(2);
                document.getElementById('satscal-input-value-from').value = calculatedValueBtcToEur;
            }
            break;
        case "BTCUSD":
            if (straight) {
                let calculatedValueBtcToEurR = (((amountFrom * oneBtcInSatoshiCal) / satoshiPerCentCal) / 100).toFixed(2);
                document.getElementById('satscal-input-value-to').value = calculatedValueBtcToEurR;
            } else {
                let calculatedValueBtcToEur = (((amountTo * oneBtcInSatoshiCal) / satoshiPerCentCal) / 100).toFixed(2);
                document.getElementById('satscal-input-value-from').value = calculatedValueBtcToEur;
            }
            break;
        case "BTCSATS":
            if (straight) {
                let calculatedValueBtcToSatsR = (amountFrom * oneBtcInSatoshiCal).toFixed(0);
                document.getElementById('satscal-input-value-to').value = calculatedValueBtcToSatsR;
            } else {
                let calculatedValueBtcToSats = (amountTo * oneBtcInSatoshiCal).toFixed(0);
                document.getElementById('satscal-input-value-from').value = calculatedValueBtcToSats;
            }
            break;
        case "EURSATS":
            if (straight) {
                let calculatedValueEurFromSatsR = ((amountFrom * 100) * satoshiPerCentCal).toFixed(0);
                document.getElementById('satscal-input-value-to').value = calculatedValueEurFromSatsR;
            } else {
                let calculatedValueEurFromSats = ((amountTo * 100) * satoshiPerCentCal).toFixed(0);
                document.getElementById('satscal-input-value-from').value = calculatedValueEurFromSats;
            }
            break;
        case "EURBTC":
            if (straight) {
                let calculatedValueEurFromBtcR = (((amountFrom * 100) * satoshiPerCentCal) / oneBtcInSatoshiCal).toFixed(8);
                document.getElementById('satscal-input-value-to').value = calculatedValueEurFromBtcR;
            } else {
                let calculatedValueEurFromBtc = (((amountTo * 100) * satoshiPerCentCal) / oneBtcInSatoshiCal).toFixed(8);
                document.getElementById('satscal-input-value-from').value = calculatedValueEurFromBtc;
            }
            break;
        case "USDSATS":
            if (straight) {
                let calculatedValueEurFromSatsR = ((amountFrom * 100) * satoshiPerCentCal).toFixed(0);
                document.getElementById('satscal-input-value-to').value = calculatedValueEurFromSatsR;
            } else {
                let calculatedValueEurFromSats = ((amountTo * 100) * satoshiPerCentCal).toFixed(0);
                document.getElementById('satscal-input-value-from').value = calculatedValueEurFromSats;
            }
            break;
        case "USDBTC":
            if (straight) {
                let calculatedValueEurFromBtcR = (((amountFrom * 100) * satoshiPerCentCal) / oneBtcInSatoshiCal).toFixed(8);
                document.getElementById('satscal-input-value-to').value = calculatedValueEurFromBtcR;
            } else {
                let calculatedValueEurFromBtc = (((amountTo * 100) * satoshiPerCentCal) / oneBtcInSatoshiCal).toFixed(8);
                document.getElementById('satscal-input-value-from').value = calculatedValueEurFromBtc;
            }
            break;
        default:
            document.getElementById('satscal-input-value-from').value = 0;
            document.getElementById('satscal-input-value-to').value = 0;
            break;
    }
}

function handleSliderChangeSatsCalFrom(event) {
    event.preventDefault();
    const root = event.target.closest('.satscal-form-from');
    const el = root.querySelector('.satscal-input-value-from');
    const price = parseInt(el.value);
    const min = parseInt(event.target.getAttribute('min'));
    const max = parseInt(event.target.getAttribute('max'));
    if (price < min) {
        el.value = min;
    } else if (price > max) {
        el.value = max;
    }
    root.querySelector('.satscal-input-range').value = el.value;
    calculateSats(true);
}

function handleSliderInputSatsCalFrom(event) {
    event.target.closest('.satscal-form-from').querySelector('.satscal-input-value-from').value = event.target.value;
    calculateSats(true);
}

function handleInputSatsCalFrom(event) {
    event.preventDefault();
    const root = event.target.closest('.satscal-form-from');
    const satscalamountfrom = parseInt(event.target.dataset.satscalamountfrom);
    if (isNaN(event.target.value)) root.querySelector('.satscal-input-value-from').value = satscalamountfrom;

    // Get dynamic max based on selected currency
    const currency = document.getElementById('satscalfrom').value;
    const dynamicMax = getMaxForCurrency(currency);
    const min = parseFloat(event.target.getAttribute('min')) || 0;
    const max = Math.min(parseFloat(event.target.getAttribute('max')) || dynamicMax, dynamicMax);

    if (parseFloat(event.target.value) < min) {
        event.target.value = min;
    } else if (parseFloat(event.target.value) > max) {
        event.target.value = max;
    }
    calculateSats(true);
}


function handleSliderChangeSatsCalTo(event) {
    event.preventDefault();
    const root = event.target.closest('.satscal-form-to');
    const el = root.querySelector('.satscal-input-value-to');
    const price = parseInt(el.value);
    const min = parseInt(event.target.getAttribute('min'));
    const max = parseInt(event.target.getAttribute('max'));
    if (price < min) {
        el.value = min;
    } else if (price > max) {
        el.value = max;
    }
    root.querySelector('.satscal-input-range').value = el.value;
    calculateSats(false);
}

function handleSliderInputSatsCalTo(event) {
    event.target.closest('.satscal-form-to').querySelector('.satscal-input-value-to').value = event.target.value;
    calculateSats(false);
}

function handleInputSatsCalTo(event) {
    event.preventDefault();
    const root = event.target.closest('.satscal-form-to');
    const satscalamountto = parseInt(event.target.dataset.satscalamountto);
    if (isNaN(event.target.value)) root.querySelector('.satscal-input-value-to').value = satscalamountto;

    // Get dynamic max based on selected currency
    const currency = document.getElementById('satscalto').value;
    const dynamicMax = getMaxForCurrency(currency);
    const min = parseFloat(event.target.getAttribute('min')) || 0;
    const max = Math.min(parseFloat(event.target.getAttribute('max')) || dynamicMax, dynamicMax);

    if (parseFloat(event.target.value) < min) {
        event.target.value = min;
    } else if (parseFloat(event.target.value) > max) {
        event.target.value = max;
    }
    calculateSats(false);
}
